// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './auth/Login';
import RegisterResponder from './auth/RegisterResponder';
import ProtectedRoute from './auth/authcontext.js';
import './App.css';

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />}/>
        <Route path="/SosResponders/login" element={<Login />} />
        <Route path="/register-responder" element={<RegisterResponder />} />
        <Route
          path="/dashboard"

          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>

          }
        />
      
        
      </Routes>
    </Router>
  );
}


export default App;
